import { useAuthStore } from '../../../stores/authStore';
import { StripeConnectSection } from '../../../components/settings/StripeConnectSection';
import { SettingsSubPage } from '../components/SettingsSubPage';

export function PaymentSetupPage() {
  const business = useAuthStore(s => s.business);

  return (
    <SettingsSubPage title="Payment setup" description="Stripe Connect — accept card payments">
      {business && <StripeConnectSection business={business} />}
    </SettingsSubPage>
  );
}
